import { useState } from 'react';
import { Button, Div, Group, ModalPageHeader, Text } from '@vkontakte/vkui';
import { DragHandle } from '../../ui/DragHandle';
import { ResizableModalPage } from '../../ui/ResizableModalPage';
import type { SortMode, StatusMode } from './taskUtils';

const STATUS_OPTS: { value: StatusMode; label: string }[] = [
  { value: 'all', label: 'Все' },
  { value: 'pending', label: 'Активные' },
  { value: 'completed', label: 'Выполненные' },
  { value: 'overdue', label: 'Просроченные' },
  { value: 'soon', label: 'Скоро срок' },
];

const SORT_OPTS: { value: SortMode; label: string }[] = [
  { value: 'position', label: 'По порядку' },
  { value: 'date', label: 'По сроку' },
  { value: 'name', label: 'По названию' },
  { value: 'category', label: 'По категории' },
  { value: 'overdue', label: 'Сначала просроченные' },
];

type Props = {
  openToken: number;
  status: StatusMode;
  sort: SortMode;
  onApply: (status: StatusMode, sort: SortMode) => void;
  onReset: () => void;
  onClose: () => void;
};

export function TaskFiltersSheet({ openToken, status, sort, onApply, onReset, onClose }: Props) {
  const [draftStatus, setDraftStatus] = useState<StatusMode>(status);
  const [draftSort, setDraftSort] = useState<SortMode>(sort);
  return (
    <ResizableModalPage openToken={openToken} id="filters" onClose={onClose} settlingHeight={60}>
      <ModalPageHeader>Фильтры</ModalPageHeader>
      <DragHandle />
      <Group>
        <Div>
          <Text style={{ marginBottom: 8 }}>Статус</Text>
          <div className="tp-filter-opts">
            {STATUS_OPTS.map((o) => (
              <button
                key={o.value}
                type="button"
                className={`tp-filter-opt${draftStatus === o.value ? ' tp-filter-opt--active' : ''}`}
                aria-pressed={draftStatus === o.value}
                onClick={() => setDraftStatus(o.value)}
              >
                {o.label}
              </button>
            ))}
          </div>
        </Div>
        <Div>
          <Text style={{ marginBottom: 8 }}>Сортировка</Text>
          <div className="tp-filter-opts">
            {SORT_OPTS.map((o) => (
              <button
                key={o.value}
                type="button"
                className={`tp-filter-opt${draftSort === o.value ? ' tp-filter-opt--active' : ''}`}
                aria-pressed={draftSort === o.value}
                onClick={() => setDraftSort(o.value)}
              >
                {o.label}
              </button>
            ))}
          </div>
        </Div>
        <Div style={{ display: 'flex', gap: 8 }}>
          <Button size="m" mode="primary" style={{ flex: 1 }} onClick={() => { onApply(draftStatus, draftSort); onClose(); }}>
            Применить
          </Button>
          <Button size="m" mode="secondary" style={{ flex: 1 }} onClick={() => { onReset(); onClose(); }}>
            Сбросить
          </Button>
        </Div>
      </Group>
    </ResizableModalPage>
  );
}
